import { Collection } from '@features/product/components/Collection/Collection.types';

const COLOR_PROPERTY_IDS = ['1006', '338301'];

export function getProductsWithCurrentColor(
  collection: Collection,
  selectedProductId?: number | null
) {
  const { discriminants, attributes } = collection;

  if (!attributes.isColorSeparated) return [];

  const colorDiscriminant = discriminants.find(discriminant => {
    if (!discriminant.referenceId) return false;

    return COLOR_PROPERTY_IDS.includes(discriminant.referenceId);
  });

  // When the dropdown collection is shown on mobile and the user clicks on a value
  // It should get the selected color value based on this, and not the isValueOfCurrentProduct anymore
  const currentSelectedColorValue = selectedProductId
    ? colorDiscriminant?.values.find(value =>
        value.products.some(product => product?.id === selectedProductId)
      )
    : colorDiscriminant?.values.find(value => value.isValueOfCurrentProduct);

  if (!currentSelectedColorValue) return [];

  const products = currentSelectedColorValue.products.filter(product => product !== null);

  return products.map(product => product.id);
}
